import { getNoneCredentialUserInfo } from '@/common/utils/scalable.player'
import cookie from '@/common/utils/cookie'
import { getUserInfo } from '@/common/utils/common'

/**
 * player -> vue 쪽으로 올려주는 이벤트 목록
 * @type {{READY: string, SET_FULLSCREEN: string, EXPIRED_CREDENTIAL: string, ALARM: string, ADULT_INPUT_PIN: string, NO_PREVIEW: string, AD_ERROR: string, SHOW_TOAST: string, PAUSE: string, SELECTED: string, ADULT_AUTHENTICATION: string, PLAY: string, END_CONTENT: string, COMPLETE: string, MOVE_PAGE: string, PROGRESS: string, CANCEL: string, NOT_SUPPORT: string, UPDATE: string, ERROR: string, ADULT_WATCH: string, REMOVED: string}}
 */
export const PLAYER_EVENT = {
  READY: 'ready',
  UPDATE: 'update',
  PLAY: 'play',
  PAUSE: 'pause',
  END: 'end',
  ALARM: 'alarm',
  PROGRESS: 'progress',
  COMPLETE: 'complete',
  SELECTED: 'selected',
  REMOVED: 'removed',
  CANCEL: 'cancel',
  ERROR: 'error',
  ADULT_AUTHENTICATION: 'adult_authentication',
  ADULT_WATCH: 'adult_watch',
  ADULT_INPUT_PIN: 'adult_input_pin',
  NOT_SUPPORT: 'not_support',
  END_CONTENT: 'end_content',
  AD_ERROR: 'ad_error',
  NO_PREVIEW: 'no_preview',
  EXPIRED_CREDENTIAL: 'expired_credential',
  SET_FULLSCREEN: 'set_fullscreen',
  SHOW_TOAST: 'show_toast',
  MOVE_PAGE: 'move_page',
  BRAZE_CUSTOM_EVENT: 'braze_custom_event',
  IS_NOT_LOGIN: 'is_not_login',
}

/**
 * vue -> player 호출 인터페이스
 * @type {{setUserInfo: (function(): Promise<*>), play: PlayerInterface.play, load: (function(*, *, *=): Promise<*>), unload: (function(): *)}}
 */
export const PlayerInterface = {
  isCreatedPlayerInstance: () => {
    return !!window.playerInstance
  },
  destructor: () => {
    if (!PlayerInterface.isCreatedPlayerInstance()) {
      console.log('not created player yet')
      return false
    }
    return window.playerInstance.destructor()
  },
  load: async (type, id, addinfo = {}) => {
    if (!PlayerInterface.isCreatedPlayerInstance()) {
      console.log('not created player yet')
      return false
    }
    return window.playerInstance.load(type, id, addinfo)
  },
  setUserInfo: async () => {
    if (!PlayerInterface.isCreatedPlayerInstance()) {
      console.log('not created player yet')
      return false
    }
    let userInfo = getNoneCredentialUserInfo()
    if (cookie.hasCredential()) {
      userInfo = await getUserInfo()
    }
    return window.playerInstance.setUserInfo(userInfo)
  },
  unload: () => {
    if (!PlayerInterface.isCreatedPlayerInstance()) {
      console.log('not created player yet')
      return false
    }
    return window.playerInstance.unload()
  },
  play: (withMessage = false) => {
    if (!PlayerInterface.isCreatedPlayerInstance()) {
      console.log('not created player yet')
      return false
    }
    if (
      window.playerInstance &&
      typeof window.playerInstance.playFromMWeb !== 'undefined'
    ) {
      window.playerInstance.playFromMWeb(withMessage)
    }
  },
  pause: () => {
    if (!PlayerInterface.isCreatedPlayerInstance()) {
      console.log('not created player yet')
      return false
    }
    if (
      window.playerInstance &&
      typeof window.playerInstance.pause !== 'undefined'
    ) {
      window.playerInstance.pause()
    }
  },
  setFullScreen: () => {
    if (!PlayerInterface.isCreatedPlayerInstance()) {
      console.log('not created player yet')
      return false
    }
    if (
      window.playerInstance &&
      typeof window.playerInstance.setFullScreen !== 'undefined'
    ) {
      window.playerInstance.setFullScreen()
    }
  },
  setMute: (mute) => {
    if (!PlayerInterface.isCreatedPlayerInstance()) {
      console.log('not created player yet')
      return false
    }
    if (
      window.playerInstance &&
      typeof window.playerInstance.setMute !== 'undefined'
    ) {
      window.playerInstance.setMute(mute)
    }
  },
}
